module.exports = __webpack_public_path__ + "assets/img/done.67fecc42.svg";